import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';


const groupByLocation = (selectedChannels) => {
  const selectedChannelsByLocation = {}
  selectedChannels.forEach(channel => {
    const locId = `${channel.network}.${channel.station}.${channel.location}`
    if (!(locId in selectedChannelsByLocation)) {
      selectedChannelsByLocation[locId] = {channels: []}
    }
    selectedChannelsByLocation[locId].stationName = channel.stationName
    selectedChannelsByLocation[locId].channels.push(channel.channel)
  });
  // object to list
  return Object.keys(selectedChannelsByLocation).map(locId => {
    const [network, station, location] = locId.split('.')
    return {locId, network, station, location, ...selectedChannelsByLocation[locId]}
  })
}


export const SelectedChannelsModal = ({selectedChannels, onClose}) => {
  const [selectedChannelsByLocation, setSelectedChannelsByLocation] = useState([])
  useEffect(() => {
    const selectedChannelsByLocation = groupByLocation(selectedChannels)
    setSelectedChannelsByLocation(selectedChannelsByLocation)
  }, [selectedChannels, setSelectedChannelsByLocation])

  const { t } = useTranslation()

  return (
    <div style={{position: 'fixed', zIndex: 10681, top: 0, left: 0, right: 0, bottom: 0}} 
      onClick={(e) => {if (e.target === e.currentTarget) { onClose() }}}
    >
      <div id="modal2" className="modal">
        <div className="modal-content">
          <div className="modal-title">{t('w.selectdChannel') + ' ' + t('w.list')}</div>
          <br/>
          <span>{t('others.tableRowCounter', {rows: selectedChannelsByLocation.length})}</span>
          <div className="overflow-auto">
            <table className="table-bordered highlight datatable mt10 table-nowrap">
              <colgroup>
                <col style={{width: "20%"}} />
                <col style={{width: "20%"}} />
                <col style={{width: "20%"}} />
                <col style={{width: "40%"}} />
              </colgroup>
              <tbody>
                <tr>
                  <th className="first">{t('w.stationCode')}</th>
                  <th className="first">{t('w.stationName')}</th>
                  <th className="first">{t('w.locationCode')}</th>
                  <th className="first">{t('w.selectdChannel')}</th>
                </tr>
                {selectedChannelsByLocation.map(channel =>(
                  <tr key={channel.locId}>
                    <td className="center-align">{channel.station}</td>
                    <td className="center-align">{channel.stationName}</td>
                    <td className="center-align">{channel.location}</td>
                    <td className="center-align">{channel.channels.join(', ')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <a className="modal-close waves-effect waves-green btn-flat" onClick={onClose}><i className="ion ion-md-close"></i></a>
        </div>
      </div>
    </div>
  )
}